import React, { useState } from "react";
import Modal from "react-modal";
import SearchNButtons from "../../common-components/SearchNButtons";
import DTForm from "./DTForm";

const DTFilters = ({
  filters,
  setFilters,
  searchFilterApplied,
  onClickSearch,
  callFunction,
}) => {
  const [modals, setModal] = useState(false);

  return (
    <>
      <Modal
        isOpen={modals}
        onRequestClose={() => {
          setModal(false);
        }}
        contentLabel="Add Meal Modal"
        ariaHideApp={false}
      >
        <DTForm
          closeModal={() => setModal(false)}
          callFunction={callFunction}
        />
      </Modal>

      <SearchNButtons
        pageName={"diet-timings"}
        btnText={"+ Add time"}
        filters={filters}
        setFilters={setFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        onClickAdd={() => setModal(true)}
      />
    </>
  );
};

export default DTFilters;
